export const PRODUCTION = "production";

// ---------------------------------------------------------------------------
// Runtime env helper
// ---------------------------------------------------------------------------
// REACT_APP_* variables are intentionally NOT baked in at build time so the
// same Docker image can be promoted through dev→stg→prd unchanged.
// docker-entrypoint.sh writes window._env = { ... } before nginx serves the
// SPA, so it is always populated in the browser.  We check it first; if for
// any reason it is absent (local dev / unit tests) we fall back to the
// webpack-generated process.env snapshot.
// ---------------------------------------------------------------------------
export const getEnv = (key) =>
  (typeof window !== "undefined" && window._env?.[key] != null
    ? window._env[key]
    : process.env[key]) ?? "";

export const isProd = () =>
  process.env.NODE_ENV === PRODUCTION &&
  window.location.href.indexOf("account.sainsburys.co.uk") !== -1;

export const isIovationEnabled = () =>
  getEnv("REACT_APP_IOVATION_ENABLED") === "true";

export const isRecapchaEnabled = () =>
  getEnv("REACT_APP_RECAPTCHA_ENABLED") === "true";

export const isLoginRecaptchaEnabled = () =>
  getEnv("REACT_APP_LOGIN_RECAPTCHA_ENABLED") === "true";

export const isWebauthnEnabledForNectar = () =>
  getEnv("REACT_APP_WEBAUTHN_ENABLED_NECTAR") === "true";

export const isWebauthnEnabledForGol = () =>
  getEnv("REACT_APP_WEBAUTHN_ENABLED_GOL") === "true";

export const isWebauthnEnabledForMyaccount = () =>
  getEnv("REACT_APP_WEBAUTHN_ENABLED_MYACCOUNT") === "true";

// Convenience accessor – returns the v3 captcha public key at runtime.
export const getCaptchaKeyV3 = () => getEnv("REACT_APP_CAPTCHA_API_KEY_v3");

// ---------------------------------------------------------------------------
// Auth URL helper — nginx proxies all backend paths so this is now a
// passthrough returning the path unchanged (relative URL).
// Kept for backward compatibility with service files.
// ---------------------------------------------------------------------------
export const getAuthUrl = (path) => path;
